import { CONFIG } from "../config.js";
import { googleSheetsService } from "../services/googleSheets.js";

/**
 * Settings Page Component
 * Premium Liquid Glass Style configuration
 */
export class SettingsPage {
  constructor() {
    this.metadata = null;
    this.currentCatTab = "income";
  }

  /**
   * Load metadata
   */
  async loadMetadata() {
    try {
      this.metadata = await googleSheetsService.getMetadata();
    } catch (error) {
      console.error("Error loading metadata:", error);
    }
  }

  /**
   * Render settings page
   */
  render() {
    return `
      <div class="page-container">
        <div class="page-header">
          <h1>🔮 ຕັ້ງຄ່າລະບົບ</h1>
          <p class="page-subtitle">ຈັດການຂໍ້ມູນພື້ນຖານ ແລະ ການຕັ້ງຄ່າບັນຊີຂອງທ່ານ</p>
        </div>

        <div class="settings-grid">
          <!-- Company Information -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">🏢 ຂໍ້ມູນບໍລິສັດ</h2>
            <div class="form-group">
              <label>ຊື່ບໍລິສັດ</label>
              <input type="text" value="${CONFIG.COMPANY_NAME}" readonly style="background: rgba(255,255,255,0.4);">
            </div>
            <div class="form-group" style="margin-top: 1rem;">
              <label>ສະກຸນເງິນຫຼັກ</label>
              <input type="text" value="${CONFIG.DEFAULT_CURRENCY}" readonly style="background: rgba(255,255,255,0.4);">
            </div>
          </div>

          <!-- Data Management -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">💾 ຈັດການຂໍ້ມູນ</h2>
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <button class="btn btn-primary" onclick="window.open('https://docs.google.com/spreadsheets/d/1111KgCiGMrHP68NJt2171Cms3zIHHWrkfyvoOASwzRs/edit?gid=1708626673#gid=1708626673', '_blank')">
                📊 ເປີດ Google Sheet
              </button>
              <button class="btn btn-secondary" id="refreshDataBtn">
                🔄 ໂຫຼດຂໍ້ມູນໃໝ່
              </button>
            </div>
            <p class="form-hint" style="margin-top: 1.5rem; line-height: 1.5;">
              📍 ທ່ານສາມາດຈັດການຂໍ້ມູນໄດ້ໂດຍກົງທີ່ນີ້ ຫຼື ໃນ Google Sheet.
            </p>
          </div>

          <!-- Categories -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">📂 ໝວດໝູ່</h2>
            
            <div class="category-tabs-container">
              <button id="catTabIncome" class="btn btn-sm ${this.currentCatTab === "income" ? "btn-primary" : "btn-secondary"} tab-btn">ລາຍຮັບ</button>
              <button id="catTabExpense" class="btn btn-sm ${this.currentCatTab === "expense" ? "btn-primary" : "btn-secondary"} tab-btn">ລາຍຈ່າຍ</button>
            </div>

            <form id="addCategoryForm" class="add-item-form responsive-form-row">
              <input type="text" name="name" placeholder="ຊື່ໝວດໝູ່ໃໝ່..." required class="input-full-width">
              <button type="submit" class="btn btn-primary btn-add">➕</button>
            </form>

            ${this.renderList(
              (this.metadata?.categories || [])
                .filter((c) =>
                  this.currentCatTab === "expense"
                    ? c.type === "ລາຍຈ່າຍ" || c.type === "expense"
                    : c.type === "ລາຍຮັບ" || c.type === "income",
                )
                .map((c) => c.name),
              "ໝວດໝູ່",
              "deleteCategory",
            )}
          </div>

          <!-- Projects -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">📁 ໂຄງການ</h2>
            <form id="addProjectForm" class="add-item-form responsive-form-row">
              <input type="text" name="name" placeholder="ຊື່ໂຄງການໃໝ່..." required class="input-full-width">
              <button type="submit" class="btn btn-primary btn-add">➕</button>
            </form>
            ${this.renderList(this.metadata?.projects || [], "ໂຄງການ", "deleteProject")}
          </div>

          <!-- Account Types -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">💳 ປະເພດບັນຊີ</h2>
            <form id="addAccountTypeForm" class="add-item-form responsive-form-row">
              <input type="text" name="name" placeholder="ຊື່ປະເພດບັນຊີໃໝ່..." required class="input-full-width">
              <button type="submit" class="btn btn-primary btn-add">➕</button>
            </form>
            ${this.renderList(
              this.metadata?.accountTypes || [],
              "ປະເພດບັນຊີ",
              "deleteAccountType",
            )}
          </div>

          <!-- Currencies -->
          <div class="glass-panel">
            <h2 class="section-title" style="font-size: 1.25rem;">💱 ສະກຸນເງິນ</h2>
            <form id="addCurrencyForm" class="add-item-form" style="display: flex; gap: 0.5rem; margin-bottom: 1rem;">
              <input type="text" name="name" placeholder="ຊື່ (e.g. Kip)" required style="flex: 2;">
              <input type="text" name="symbol" placeholder="ສັນຍາລັກ (e.g. ₭)" required style="flex: 1;">
              <button type="submit" class="btn btn-primary" style="padding: 0.5rem 1rem;">➕</button>
            </form>
            ${this.renderCurrencyList(this.metadata?.currencies || [])}
          </div>
        </div>

        <!-- About -->
        <div class="glass-panel" style="margin-top: 3rem; text-align: center; background: linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.4) 100%);">
          <h2 class="section-title" style="justify-content: center; font-size: 1.4rem;">ℹ️ ກ່ຽວກັບລະບົບ</h2>
          <div style="margin-top: 1rem;">
            <p style="font-weight: 800; color: var(--primary-green-dark); font-size: 1.2rem;">ລະບົບບັນຊີລາຍຮັບລາຍຈ່າຍ ທິບພະລັງສີ</p>
            <p style="font-size: 1rem; color: var(--text-secondary); margin-top: 0.5rem; font-weight: 600;">ເວີຊັນລ່າສຸດ: 2.5.0 Premium Glass</p>
            <div style="margin-top: 2rem; border-top: 1px solid rgba(0,0,0,0.05); padding-top: 1.5rem;">
               <p style="font-size: 0.85rem; color: var(--text-light);">© 2026 ${CONFIG.COMPANY_NAME}. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Render a list of items with delete buttons
   */
  renderList(items, emptyText, deleteAction) {
    if (!items || items.length === 0) {
      return `<p style="text-align: center; color: var(--text-light); padding: 2rem;">ບໍ່ມີ${emptyText}</p>`;
    }

    const isScrollable = items.length > 10;
    const listClass = isScrollable
      ? "settings-list scrollable"
      : "settings-list";

    return `
      <ul class="${listClass}">
        ${items
          .map(
            (item) => `
          <li class="settings-list-item" style="display: flex; justify-content: space-between; align-items: center;">
            <span>${item}</span>
            <button class="btn-delete" data-action="${deleteAction}" data-id="${item}" style="background: none; border: none; cursor: pointer; color: #ef4444; padding: 4px;">
              🗑️
            </button>
          </li>`,
          )
          .join("")}
      </ul>
      <p style="font-size: 0.85rem; color: var(--text-light); margin-top: 1.2rem; text-align: right; font-weight: 600;">
        ລວມ: ${items.length} ${emptyText}
      </p>
    `;
  }

  /**
   * Render currency list
   */
  renderCurrencyList(currencies) {
    if (!currencies || currencies.length === 0) {
      return '<p style="text-align: center; color: var(--text-light); padding: 2rem;">ບໍ່ມີສະກຸນເງິນ</p>';
    }

    const isScrollable = currencies.length > 10;
    const listClass = isScrollable
      ? "settings-list scrollable"
      : "settings-list";

    return `
      <ul class="${listClass}">
        ${currencies
          .map(
            (currency) => `
          <li class="settings-list-item" style="color: var(--accent-blue); background: rgba(59,130,246,0.1); border-color: rgba(59,130,246,0.2); display: flex; justify-content: space-between; align-items: center;">
            <span>${currency.name} (${currency.symbol})</span>
            <button class="btn-delete" data-action="deleteCurrency" data-id="${currency.name}" style="background: none; border: none; cursor: pointer; color: #ef4444; padding: 4px;">
              🗑️
            </button>
          </li>
        `,
          )
          .join("")}
      </ul>
      <p style="font-size: 0.85rem; color: var(--text-light); margin-top: 1.2rem; text-align: right; font-weight: 600;">
        ລວມ: ${currencies.length} ສະກຸນເງິນ
      </p>
    `;
  }

  /**
   * Initialize settings page
   */
  initialize() {
    this.currentCatTab = this.currentCatTab || "income";

    const refreshBtn = document.getElementById("refreshDataBtn");
    if (refreshBtn) {
      refreshBtn.addEventListener("click", () => this.refreshData());
    }

    // Category Tabs
    const catTabIncome = document.getElementById("catTabIncome");
    const catTabExpense = document.getElementById("catTabExpense");
    if (catTabIncome && catTabExpense) {
      catTabIncome.addEventListener("click", () => {
        this.currentCatTab = "income";
        this.refreshUI();
      });
      catTabExpense.addEventListener("click", () => {
        this.currentCatTab = "expense";
        this.refreshUI();
      });
    }

    // Event Delegation for Delete Buttons
    const container = document.querySelector(".page-container");
    if (container) {
      container.addEventListener("click", (e) => {
        if (
          e.target.classList.contains("btn-delete") ||
          e.target.parentElement?.classList.contains("btn-delete")
        ) {
          const btn = e.target.classList.contains("btn-delete")
            ? e.target
            : e.target.parentElement;
          const action = btn.dataset.action;
          const id = btn.dataset.id;

          this.showDeleteConfirmation(id, async () => {
            await this.handleDelete(action, id);
          });
        }
      });
    }

    // Add Forms
    this.setupForm("addProjectForm", async (data) =>
      googleSheetsService.addProject(data.name),
    );
    this.setupForm("addAccountTypeForm", async (data) =>
      googleSheetsService.addAccountType(data.name),
    );
    this.setupForm("addCurrencyForm", async (data) =>
      googleSheetsService.addCurrency(data.name, data.symbol),
    );
    this.setupForm("addCategoryForm", async (data) => {
      const type = this.currentCatTab === "income" ? "ລາຍຮັບ" : "ລາຍຈ່າຍ";
      return googleSheetsService.addCategory(data.name, type);
    });
  }

  setupForm(formId, submitAction) {
    const form = document.getElementById(formId);
    if (!form) return;

    // Remove existing listeners to prevent duplicates if re-initialized
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    newForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const submitBtn = newForm.querySelector("button[type=submit]");
      const originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = "⏳";

      try {
        const formData = new FormData(newForm);
        const data = Object.fromEntries(formData.entries());

        await submitAction(data);

        newForm.reset();
        await this.refreshData(false); // Refresh data without full page reload
      } catch (error) {
        alert("Error: " + error.message);
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    });
  }

  async handleDelete(action, id) {
    try {
      let type = null;
      if (action === "deleteCategory") {
        type = this.currentCatTab === "income" ? "ລາຍຮັບ" : "ລາຍຈ່າຍ";
        await googleSheetsService.deleteCategory(id, type);
      } else if (action === "deleteProject") {
        await googleSheetsService.deleteProject(id);
      } else if (action === "deleteAccountType") {
        await googleSheetsService.deleteAccountType(id);
      } else if (action === "deleteCurrency") {
        await googleSheetsService.deleteCurrency(id);
      }
      await this.refreshData(false);
    } catch (error) {
      alert("Error deleting: " + error.message);
    }
  }

  refreshUI() {
    const container = document.querySelector(".page-container");
    if (container) {
      container.innerHTML = this.render()
        .replace('<div class="page-container">', "")
        .replace("</div>", "");
      this.initialize();
    }
  }

  /**
   * Show custom delete confirmation modal
   */
  showDeleteConfirmation(itemName, onConfirm) {
    // Remove existing modal if any
    const existingModal = document.getElementById("deleteModal");
    if (existingModal) existingModal.remove();

    const modalHtml = `
      <div class="modal-overlay active" id="deleteModal">
        <div class="modal-container">
          <div class="modal-icon">⚠️</div>
          <h3 class="modal-title">ຢືນຢັນການລຶບ</h3>
          <p class="modal-message">
            ທ່ານຕ້ອງການລຶບ <strong>"${itemName}"</strong> ແທ້ບໍ່?<br>
            ການກະທຳນີ້ບໍ່ສາມາດຍົກເລີກໄດ້.
          </p>
          <div class="modal-actions">
            <button class="modal-btn modal-btn-cancel" id="cancelDeleteBtn">ຍົກເລີກ</button>
            <button class="modal-btn modal-btn-confirm" id="confirmDeleteBtn">ຢືນຢັນການລຶບ</button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHtml);

    const modal = document.getElementById("deleteModal");
    const cancelBtn = document.getElementById("cancelDeleteBtn");
    const confirmBtn = document.getElementById("confirmDeleteBtn");

    const closeModal = () => {
      modal.classList.remove("active");
      setTimeout(() => modal.remove(), 300);
    };

    cancelBtn.addEventListener("click", closeModal);

    // Close on click outside
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    confirmBtn.addEventListener("click", async () => {
      confirmBtn.disabled = true;
      confirmBtn.textContent = "ກຳລັງລຶບ...";
      await onConfirm();
      closeModal();
    });
  }

  /**
   * Refresh data
   */
  async refreshData(showLoading = true) {
    const btn = document.getElementById("refreshDataBtn");
    if (btn && showLoading) {
      btn.disabled = true;
      btn.innerHTML = "<span>⏳ ກຳລັງໂຫຼດ...</span>";
    }

    try {
      await this.loadMetadata();
      // Re-render
      const mainContent = document.getElementById("mainContent");
      if (mainContent) {
        mainContent.innerHTML = this.render();
        this.initialize();
      }
    } catch (error) {
      alert("ເກີດຄວາມຜິດພາດ: " + error.message);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = "🔄 ໂຫຼດຂໍ້ມູນໃໝ່";
      }
    }
  }
}
